<template>
  <Carousel :autoplay="6800" :wrap-around="true">
    <Slide key="index1">
      <div class="carousel__item">
        <img :src="photo" style="background: white; width: 100%" />
      </div>
    </Slide>
    <Slide key="index2">
      <div class="carousel__item">
        <img :src="photo2" style="background: white; width: 100%" />
      </div>
    </Slide>
    <Slide key="index3">
      <div class="carousel__item">
        <img :src="photo3" style="background: white; width: 100%" />
      </div>
    </Slide>
    <Slide v-if="includeRoulette" key="index4">
      <div class="carousel__item">
        <img :src="photoRoulette" style="background: white; width: 100%" />
      </div>
    </Slide>
    <!-- <Slide key="index4">
      <div class="carousel__item">
        <img :src="photo2" style="background: white; width: 100%" />
      </div>
    </Slide> -->

    <!-- <template #addons>
      <Pagination />
    </template> -->
  </Carousel>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default {
  name: "Autoplay",
  components: {
    Carousel,
    Slide,
  },
  props: {
    includeRoulette: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      photo: require("@/assets/img/Saludsa/refiere_y_gana.jpeg"),
      photo2: require("@/assets/img/Saludsa/como_funciona.jpeg"),
      photo3: require("@/assets/img/Saludsa/como_refiero.jpeg"),
      photoRoulette: require("@/assets/img/Saludsa/referidos_ruleta.png"),
    };
  },
};
</script>

<style>
.carousel__viewport {
  display: flex;
  overflow: hidden;
}
</style>
